import React, { memo } from "react";
import { Label, DatePickerComponent } from "../";

const DateRangePicker = ({
  values,
  setFieldValue,
  className = "col-lg-2 col-md-6 col-12",
  startMinDate = new Date(),
}) => {
  return (
    <>
      <div className={className}>
         <div className="input_control">
        <Label htmlFor="startDate" className="form-label">
          Start Date <span className="text-danger">*</span>
        </Label>
        <DatePickerComponent
          selectedDate={values.startDate}
          onChange={(date) => {
            setFieldValue("startDate", date);
            setFieldValue("endDate", null);
          }}
          placeholderText="Pick a start date"
          // minDate={startMinDate}
          isClearable={false}
          dateFormat="dd-MM-yyyy"
        />
        </div>
      </div>
      <div className={className}>
        <div className="input_control">
        <Label htmlFor="endDate" className="form-label">
          End Date <span className="text-danger">*</span>
        </Label>
        <DatePickerComponent
          selectedDate={values.endDate}
          onChange={(date) => setFieldValue("endDate", date)}
          placeholderText="Pick an end date"
          // minDate={values.startDate}
          isClearable={false}
          disabled={!values.startDate}
          dateFormat="dd-MM-yyyy"
        />
        </div>
      </div>
    </>
  );
};

export default memo(DateRangePicker);
